/**
 * The catalog page keeps its kind, drill-down and filter state in the URL query
 * string. Remembering the last such URL lets entity pages return the user to the
 * view they left, rather than a reset catalog.
 */
const STORAGE_KEY = 'catalog:last-view';

export function rememberCatalogView(url: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, url);
  } catch {
    // Private-mode or storage-disabled browsers simply lose the shortcut.
  }
}

export function lastCatalogView(fallback = '/catalog'): string {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || fallback;
  } catch {
    return fallback;
  }
}
